import { Box, CssBaseline } from "@mui/material";
import useBaseCss from "hooks/useBaseCss";
import LeftMenuLayout from "layouts/LeftMenuLayout";
import { useEffect } from "react";
import contextStore, { ContextStore } from "stores/contextStore";
import { OrganizationContextStorage } from "utils/organizationContextStorage";

const App = () => {
  useBaseCss();
  useEffect(() => {
    const contextData = OrganizationContextStorage.get();

    if (contextData) {
      contextStore.update((s) => {
        s.organization = contextData.organization;
      });
    }
  }, []);

  const { organization } = contextStore.useState();

  useEffect(() => {
    if (organization !== null) {
      const contextObject = {
        organization,
      } as ContextStore;

      OrganizationContextStorage.set(contextObject);
    }
  }, [organization]);

  return (
    <Box sx={{ displayPrint: "none" }}>
      <CssBaseline />
      <LeftMenuLayout />
    </Box>
  );
};

export default App;
